<template>
	 <v-card flat class="px-3">
		<v-layout v-if="changeArray.length>0" class="mr-4 pr-3">
	    	<v-flex xs6 class="mr-4">
	    		<v-btn block @click="showConfirmListChangesDialog=true" class="ml-3 mr-4" color="blue lighten-1">Save</v-btn>
	    	</v-flex>
	    	<v-flex xs6>
	    		<v-btn block @click="cancel" class="ml-3 mr-4" color="blue lighten-1">Cancel</v-btn>
	    	</v-flex>
	    </v-layout>
	 	<v-list class="ddLists pb-0 pr-2" dense >
	 		<v-list-tile class="mb-3 pb-1"	 			
	 			style="border-width: .5px !important; border-bottom: solid; border-color: grey; ">
	 			<v-layout row align-center class="body-2">
					<v-flex xs2 class="pl-1">ID</v-flex>
					<v-flex>Name</v-flex>
					<v-flex xs1 v-if="showSuper">Super</v-flex>
					<v-flex xs1></v-flex>
				</v-layout>
	 		</v-list-tile>
			<v-list-tile v-for="(item, index) in localItems" :key="index">		
				<v-layout column>
				<v-layout row align-center>

					<v-flex xs2 >
					<v-edit-dialog @click.native.stop class="body-1"
	                            :return-value.sync="item.id"

	                            lazy>
	                            {{ item.id }} 	                            
	                            <v-text-field style="width: 300px;"                   
	                              slot="input"
	                              v-model="item.id"
	                              background-color="blue lighten-4"
	                              label="ID"
	                              single-line
	                              flat solo 
	                              hide-details
	                              :readonly = "item.new ? false: true"
	                              @change="addToChanged(item)"	
			                      autofocus>
	                            </v-text-field>
                        </v-edit-dialog>						

					</v-flex>
					<v-flex xs8 class="">
						<v-edit-dialog @click.native.stop class="body-1"
	                            :return-value.sync="item.name"
	                            lazy>
	                            {{ item.name }}                            
	                            <v-text-field style="width: 300px;"                   
	                              slot="input"
	                              v-model="item.name"
	                              label="Name"
	                              background-color="blue lighten-4"
	                              single-line
	                              flat solo 
	                              hide-details
	                              @change="addToChanged(item)"                
	                              autofocus>
	                            </v-text-field>
                        </v-edit-dialog>						
					</v-flex>
					<v-spacer></v-spacer>
					<v-flex xs1 v-if="showSuper" class="ml-2">
						<v-edit-dialog @click.native.stop class="body-1 text-xs-right"
	                            :return-value.sync="item.super"
	                            lazy>
	                            {{ item.super }}                            
	                            <v-text-field style="width: 300px;"                 
	                              slot="input"
	                              v-model="item.super"
	                              background-color="blue lighten-4"
	                              label="Super"
	                              single-line
	                              flat solo 
	                              hide-details
	                              @change="addToChanged(item)"                
	                              counter>
	                            </v-text-field>
                        </v-edit-dialog>						
					</v-flex>
					<!-- This causing severe performance issues on long lists 100+ items.  Had to switch to text-edit instead -->
<!-- 				<v-flex xs3 v-if="showSuper" >
						<v-autocomplete class="slimAutoComplete body-1"
							:items="superItems"
							item-text="superID"
							item-value="superID"
							@change="addToChanged(item)"
							v-model="item.super"
							flat solo
							single-line
							hide-no-data
							hide-details
							label="Super"							
						></v-autocomplete>
					</v-flex> -->

					
				<v-flex xs1 class="text-xs-right">
						<v-tooltip top>		              				                
			                <v-icon small slot="activator" color="red lighten-2" @click="delItem(item, index)">close</v-icon>          
				            <span>Delete</span>
			            </v-tooltip>
					</v-flex>
				</v-layout>
				<v-divider></v-divider>
			</v-layout>

			</v-list-tile>
		</v-list> 
		<v-flex class=""><v-btn icon @click="addLine" ><v-icon color="grey darken-2">add</v-icon></v-btn></v-flex>

		<confirmListChangesDialog 
			v-on:cancel="cancel" 
			v-on:save="save"
			:title="title"
			:changeArray="changeArray" 
			:show="showConfirmListChangesDialog" />

	</v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import confirmListChangesDialog from './confirmListChangesDialog'

export default {
name: 'ddEditor',
data () {
	return {
		changeArray: [],
		showConfirmListChangesDialog: false,
		localItems: this.items,

	}
},

mounted: function () {
	//This doesn't seem to work.  
	//console.log("Stated")
	this.$emit('updateLoading', true)	
  	this.$nextTick(function () {
    	//console.log("Finished")
    	this.$emit('updateLoading', false)
 	})
},

components: { confirmListChangesDialog },

computed: {
	...mapState({	superCategories: 	state => state.lists.superCategories,
					categories: 		state => state.lists.categories,		}),

// Powers the autocompletes that were taken out due to performance issues.
/*	superItems: function () {
		let items = []
		if (this.title == "Categories") {
			this.superCategories.forEach((item) => {
				items.push({'superID': item.superCategoryID})
			})
		} else if (this.title == "Type Codes") {
			this.categories.forEach((item) => {
				items.push({'superID': item.categoryID})
			})
		} 
		console.log("Super Items: ", items)
		return items
	},*/

	showSuper: function () {
		const superList = [ 'Type Codes', 'Categories' ]
		if (JSON.stringify(superList).includes(this.title)) {
			return true
		}
	}
},

props: [ 'items', 'title', ],

methods : {
	...mapMutations([ 'setSnackText'	]),
	...mapActions([ 'updateLists', 'refreshLists' ]),

	clickHandler : function () {
		console.log("Clicked")
	}, 

	save: async function () {
		const payload = { table: this.title, changeArray: this.changeArray }
		
		const response = await this.updateLists(payload)
		this.setSnackText(response)
		this.refreshLists()	
		this.cancel()
	},

	addToChanged : function (item) {
		// reject if ID is 'ID'
		if (item.id == "ID") { return }
		if (item.name == "Name") { return }

		// Ensure this is not a duplicate
		if (!this.changeArray.find((existing) => existing.id == item.id && existing.name == item.name )) {
			this.changeArray.push(item)
		}
		//console.log(this.changeArray)
	},

	delItem: function (item, index) {
		console.log("Del")
		this.changeArray.push( {id: item.id, name: "DELETE"} )
		this.items.splice(index, 1) // Remove from local memory
	},

	cancel: function () {
		this.changeArray = []
		this.showConfirmListChangesDialog = false
		this.$emit('reset')
	},

	addLine: function () {
		console.log("Add Line")
		this.localItems.push({ id: 'ID', name: 'Name', new: true })
		//console.log(this.items)
	}

},
}

</script>

<style>
.ddLists .v-list__tile {
   align-items:  flex-start;
   height: auto !important;
}

.slimAutoComplete .v-input__control {
	min-height: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/ddEditor.vue